import {
  gtcScrollLock,
  gtcScrollUnlock,
  gtcDebounce,
  gtcSetPreviousFocus,
  gtcTrapFocus,
  gtcRemoveTrapFocus
} from "gtcUtils";

class SpotlightSearch extends HTMLElement {
  constructor() {
    super();
    this.click = this.click.bind(this);
  }

  connectedCallback() {
    this.dom = {
      placeholder: document.querySelector("[data-spotlight-search-placeholder]"),
      form: this.querySelector("form"),
      container: this.querySelector(".gtc-spotlight-search__container"),
      input: this.querySelector("input"),
      searchResults: this.querySelector("#gtc-predictive-search"),
    }

    this.settings = {
      open: false,
      noSearchTemplate: this.querySelector("[data-no-search-template]").innerHTML,
    }

    this.addEventListeners();
  }


  addEventListeners() {
    if (this.dom.placeholder) {
      this.dom.placeholder.addEventListener("click", this.open.bind(this));
    }

    document.addEventListener("click", this.click);
    document.addEventListener("keydown", this.closeOnEscape.bind(this));
    window.addEventListener("resize", gtcDebounce(this.updateSpotlightSearch.bind(this), 100));

    this.addEventListener("click", this.quickSearchButtonClick.bind(this));

    document.addEventListener("gtcPredictiveSearch:clear", () => {
      this.dom.searchResults.innerHTML = this.settings.noSearchTemplate;
    });

    document.addEventListener("gtcPredictiveSearch:searchComplete", () => {
      gtcTrapFocus(this);
    });

    document.addEventListener('variant:added', this.close.bind(this));
  }


  disconnectedCallback() {
    console.dir('disconnected', { depth: null });
    if (this.dom.placeholder) {
      this.dom.placeholder.removeEventListener("click", this.this.openSpotlightSearch);
    }
    document.removeEventListener("click", this.click);
    document.removeEventListener("keydown", this.closeOnEscape.bind(this));
    window.removeEventListener("resize", gtcDebounce(this.updateSpotlightSearch, 100));

    this.removeEventListener("click", this.quickSearchButtonClick);
  }

  click(event) {
    if (this.classList.contains("gtc-spotlight-search--active") && !this.dom.container.contains(event.target)) {
      this.close();
    }
  }


  quickSearchButtonClick(event) {
    if (event.target.matches('button[data-suggestion]')) {
      if (this.dom.input) {
        this.dom.input.value = event.target.getAttribute("data-suggestion").trim();
        this.dom.input.dispatchEvent(new Event("input"));
      }
    }
  }

  open(event) {
    if (event) event.stopPropagation();
    if (!this.dom.placeholder || !this.dom.form) return;
    gtcSetPreviousFocus(this.dom.placeholder);

    this.settings.open = true;
    this.updateSpotlightSearch();
    this.classList.add("gtc-spotlight-search--active");

    gtcTrapFocus(this);
    gtcScrollLock();
  }

  close() {
    this.dom.input.value = "";
    this.dom.searchResults.innerHTML = this.settings.noSearchTemplate;

    this.classList.remove("gtc-spotlight-search--active");
    this.settings.open = false;
    gtcScrollUnlock()
    window.requestAnimationFrame(() => {
      gtcRemoveTrapFocus(this);
    }, 20);
  }

  updateSpotlightSearch() {
    if (this.settings.open !== true) return;

    const rect = this.dom.placeholder.getBoundingClientRect();
    const placeholderInnerHeight = this.dom.placeholder.clientHeight - parseInt(getComputedStyle(this.dom.placeholder).paddingTop) - parseInt(getComputedStyle(this.dom.placeholder).paddingBottom);
    const windowInnerHeight = window.innerHeight;

    this.dom.container.style.position = "absolute";
    this.dom.container.style.top = `${ rect.top }px`;

    // if window is smaller than  1200px, use window.matchMedia to check
    if (rect.width < 800) {
      this.dom.container.style.left = "50%";
      this.dom.container.style.width = "calc(100vw - 48px)";
      this.dom.container.style.maxWidth = "800px";
      this.dom.container.style.transform = "translateX(-50%)";
      // this.dom.form.style.setProperty('--form-max-height', `${ windowInnerHeight - rect.top - placeholderInnerHeight - 36 }px`);
    } else {
      this.dom.container.style.left = `${ rect.left }px`;
      this.dom.container.style.transform = "unset";
      this.dom.container.style.width = `${ rect.width }px`;
      this.dom.container.style.maxWidth = "unset";
    }


    const formMaxHeight = windowInnerHeight - rect.top - placeholderInnerHeight - 36;
    this.dom.container.style.setProperty('--form-max-height', `${ formMaxHeight }px`);
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && this.settings.open) {
      event.preventDefault();
      this.close();
    }
  }
}

if (!customElements.get("gtc-spotlight-search")) {
  customElements.define("gtc-spotlight-search", SpotlightSearch);
}
